var radioBtnData = {
  name: 'radioButton',
  data: [{
    fontFamily: '',
    fontSize: 13,
    fontColor: '#0F1358',
    radius: 4,
    btnHeight: 32,
    btnPadding: '0 8px',
    btnBoxShadow: 'none',
    borderColor: '#D9E6F2',
    checkedFontColor: '#5365EA',
    checkedBorderColor: '#5365EA',
    checkedBgColor: 'white',
    disabledFontColor: 'rgba(58,52,95,0.36)',
    disabledBorderColor: '#D9E6F2',
    disabledBgColor: '#F5F6FA',
    checkedDisableBorderColor: '#D9E6F2',
    checkedDisableFontColor: '#5365EA',
    checkedDisableBgColor: '#F5F6FA',
    groupBorderRadius: 4,
    groupBorderRadiusOther: 0,
    verticalAligin: 'middle'
  }]
};
export default radioBtnData;